import React from "react";

const COLORS = {
  new: { bg: "#dbeafe", color: "#2563eb" },
  contacted: { bg: "#fef3c7", color: "#d97706" },
  replied: { bg: "#dcfce7", color: "#16a34a" },
  meeting_booked: { bg: "#e0e7ff", color: "#4f46e5" },
  sent_pricing: { bg: "#fce7f3", color: "#db2777" },
  sent_contract: { bg: "#f0fdfa", color: "#0d9488" },
  not_interested: { bg: "#fee2e2", color: "#dc2626" },
  closed: { bg: "#f3f4f6", color: "#6b7280" },
};

const LABELS = {
  new: "New",
  contacted: "Contacted",
  replied: "Replied",
  meeting_booked: "Meeting Booked",
  sent_pricing: "Sent Pricing",
  sent_contract: "Sent Contract",
  not_interested: "Not Interested",
  closed: "Closed",
};

export default function LeadStatusBadge({ leadStatus }) {
  const style = COLORS[leadStatus] || COLORS.new;
  return (
    <span className="badge" style={{ background: style.bg, color: style.color }}>
      {LABELS[leadStatus] || leadStatus}
    </span>
  );
}
